var CLS_HIDE = 'd-none';
var CLS_CHECKED = 'has-checked';

Core.AddToQuote = {
    init: function () {        
        Core.AddToQuote.Cache = {
            addToQuoteSelector: (!this.isPortal()) ? '.addToQuote' : '.addToCartPortal',
            $rentBtn: $('.rent'),
            $trialBtn: $('.trial'),
            $groupPrice: $('#groupPrice'),
            $groupCode: $('#groupCode'),
            $productDetailContainer: $('#product-detail'),
            $productListingPage: $('#product-listing'),
        };

        this.initAddToCartQuoteListener();
    },

    initAddToCartQuoteListener: function() {
        // Community Website
        if (this.isEventBased()) {
            document.addEventListener('aidacare.addtocart', function(e) {
                Core.ShowPageLoading();
                Core.AddToQuote.addToCartPortalApi(e.detail.itemList);
            });

            return;
        }

        // Portal Website
        if (this.isPortal()) {
            this.addVariantsPortal();
            this.addToCartPortal();
            return;
        }

        // Corporate Website
        this.addVariants();
        this.addToQuote();
    },

    addVariants: function () {
        window.selectedVariants = [];

        // On click - main product blue button - add to cart
        Core.Cache.$document.on("click", '.product-details__variant--cart', function () {
            var _$this = $(this);
            if (_$this.hasClass('disabled')) { return false; }

			// User is adding an item to the cart, button isn't disabled
            var _sku = _$this.data('id'),
				_price = _$this.data('price'),
                _minQty = parseInt(_$this.data('minqty')),
                _maxQty = parseInt(_$this.data('maxqty')),
				_$variant = _$this.parents('.product-details__variant');
            
            var stockData = Core.AddToQuote.getStockData(_$this.closest('.product-details__variant'));

            _$this.toggleClass('added');
            _$variant.toggleClass('selected');

            if (_$this.hasClass('added')) {
				// Add initial item
                selectedVariants.push({
					sku: _sku,
					qty: _minQty,
					price: _price,
                    stockcolor: stockData.stockColor,
                    stockmessage: stockData.stockMessage,
				});
            } else {
				// Remove item from cart
                for (var i = 0; i < selectedVariants.length; i++) {
                    if (selectedVariants[i]['sku'] == _sku) {
                        selectedVariants.splice(selectedVariants.indexOf(selectedVariants[i]), 1);
                        break;
                    }
                }
            }

			// Get product code ID's
            var productCode = $('span.added');
            var blkstr = [];
            $.each(productCode, function(i, e) {
                blkstr.push( $(e).data('id') );
            });

            if (selectedVariants.length === 0) {
                $(Core.AddToQuote.Cache.addToQuoteSelector)
					.add(Core.AddToQuote.Cache.$rentBtn)
					.add(Core.AddToQuote.Cache.$trialBtn)
					.addClass('disabled');
            } else {
                $(Core.AddToQuote.Cache.addToQuoteSelector)
					.add(Core.AddToQuote.Cache.$rentBtn)
					.add(Core.AddToQuote.Cache.$trialBtn)
					.removeClass('disabled');
            }

			// Handle Kendo Number Box
            var _$variantParent = _$this.parent();
            if (_$variantParent.find('.k-numerictextbox').length > 0) {
                _$variantParent.find("input[name='qty']").data('kendoNumericTextBox').value(1);
                _$variantParent.find('.k-numerictextbox').toggle();
            } else {
                //$(".product-details__selections").find('.k-numerictextbox').enable(true);
                var _$selectionQuantity = $('.product-details__selections').find('#selection_qty');
                this.numerictextbox = _$selectionQuantity.data('kendoNumericTextBox');
                this.numerictextbox.enable( _$this.hasClass('added') );

            }

            if (Core.AddToQuote.Cache.$productDetailContainer.length > 0) {
                Core.ProductDetail.Cache.$rentalForm.find('.productCode').val(blkstr.join(','));
                Core.ProductDetail.Cache.$trialForm.find('.productCode').val(blkstr.join(','));

                var $pdVariant = _$variantParent.closest('.product-details__variant');
                var $relatedProducts = $pdVariant.find('.related-products') || _$variantParent.siblings('.related-products');
                $relatedProducts.slideToggle(400, function () {

                });
            }

			// Group Pricing
            var _groupPrice = 0;
            var _$groupCodeStr = [];
            for (var x = 0; x < selectedVariants.length; x++) {
                _groupPrice += parseFloat(selectedVariants[x].price * selectedVariants[x].qty);
                _$groupCodeStr.push(selectedVariants[x].sku);
            }

            if (_$groupCodeStr.length === 0) {
                Core.AddToQuote.Cache.$groupPrice.hide();
                Core.AddToQuote.Cache.$groupCode.hide();
                if (Core.AddToQuote.Cache.$productDetailContainer.length > 0) {
                    Core.ProductDetail.Cache.$trialForm.hide();
                    Core.ProductDetail.Cache.$rentalForm.hide();
                }
            } else {
                if (_groupPrice > 0) {
                    Core.AddToQuote.Cache.$groupPrice.text('$' + _groupPrice.toFixed(2)).show();
                } else {
                    Core.AddToQuote.Cache.$groupPrice.text(Core.Config.POA.Text).show();
                }

                if (_$groupCodeStr.length === 1) {
                    Core.AddToQuote.Cache.$groupCode.text("SKU# " + _$groupCodeStr.join(", ")).show();
                } else {
                    Core.AddToQuote.Cache.$groupCode.text("SKU# " + "Multiple Selections").show();
                }
            }
        });

        // On click - accessories product blue button - add to cart
        Core.Cache.$document.on("click", '.product-details__variant--title span.next-item', function () {
            var _$this = $(this);

            // Close current group accordian and deselect any previously selected variants
            var _$parentGroup = _$this.closest(".related-products__accordion-item");
            _$parentGroup.find("span.added").trigger("click");
            _$parentGroup.find(".related-products__accordion-tab").trigger("click");

            /* Disabling this because it's supposed to only close the parent item and not open next one
             * However still want this commented out in the code just in case Aidacare changes their mind on this.
            var _$nextGroup;
            if (_$parentGroup.next().length > 0) {
                _$nextGroup = _$parentGroup.next();
            } else {
                var _$parentParentGroup = _$parentGroup.closest(".related-products__accordion-content").closest(".related-products__accordion-item");
                if (_$parentParentGroup.next().length > 0) {
                    _$nextGroup = _$parentParentGroup.next();
                }
            }

            _$nextGroup.find(".related-products__accordion-tab").trigger("click");//*/
        });
    },

    addToQuote: function () {
        Core.Cache.$document.on("click", Core.AddToQuote.Cache.addToQuoteSelector, function () {
            var _$this = $(this);
            if (!_$this.hasClass('disabled')) {
                Core.ShowPageLoading();

                Core.AddToQuote.Cache.$rentBtn.removeClass('selected');
                Core.AddToQuote.Cache.$trialBtn.removeClass('selected');
                var stockData = Core.AddToQuote.getStockData(_$this.closest('.product-details__variant'));
                
                if (selectedVariants.length === 0) {
                    var _variant = {};

                    _variant.sku = _$this.data('id');
                    _variant.qty = 1;
                    _variant.stockcolor = stockData.stockColor;
                    _variant.stockmessage = stockData.stockMessage;

                    selectedVariants.push(_variant);
                }

                var addToCartRequest = {
                    cartItems: selectedVariants,
                };

                $.post('/cart/addtoquote?_=' + new Date().getTime().toString(), { '': selectedVariants }).
                    success(function (data, status, headers, config) {
                        Core.HidePageLoading();

                        Core.Engine.getCartSummary();

                        var _width = Core.Config.CartNotification.Width,
                            _height = Core.Config.CartNotification.Height;

                        if (Core.IsMobile()) {
                            _width = Core.Cache.$window.width();
                        }

                        //check which items have been successful
                        var _successfulItems = [];
                        for (var x = 0; x < data.length; x++) {
                            _successfulItems.push(data[x]);
                        }

                        if (_successfulItems.length > 0) {
                            //increase height of window if more than 2 items
                            if (_successfulItems.length > 2) {
                                _height = _height + (_successfulItems.length - 2) * 35;
                            }

                            Core.RenderTemplate('#tpl-cart-notification', _successfulItems, $('#cart-notification-content'));

                            var _$addToCartWindow = $('#cart-notification');

                            _$addToCartWindow = _$addToCartWindow.kendoWindow({
                                width: _width, height: _height, visible: false, iframe: false, modal: true, resizable: false, pinned: true, draggable: false, appendTo: '#page-wrap'
                            });

                            _$addToCartWindow.data("kendoWindow").center().open();

                            $(".k-overlay").on('click', function () {
                                _$addToCartWindow.data("kendoWindow").close();
                            });

                            $(".k-window-action > span.k-i-close, .cart-notification-buttons > a.k-i-close").on('click', function (e) {
                                e.preventDefault();
                                _$addToCartWindow.data("kendoWindow").close();
                            });

                            window.selectedVariants = [];

                            if (Core.ProductDetail.Cache) {
                                Core.ProductDetail.closeFormField(Core.ProductDetail.Cache.$trialForm);
                                Core.ProductDetail.closeFormField(Core.ProductDetail.Cache.$rentalForm);
                            }
                        }
                        else {
                            //todo: do something when no items have been added
                            alert('Sorry, that was a problem adding items to your cart');
                        }
                }).error(function (data, status, headers, config) {
                    //todo: do something
                });
            }
        });
    },

    /**

        DYNAMIC PRICE
        - getDynamicPrice
        - updatePrice
        - resetOriginalPrice
        - updatePriceLabel
        - resetOriginalPriceLabel

     */

    // STR : DYNAMIC PRICE -------------------------------
    getDynamicPrice: function(sku, qty) {
        // var url = 'https://run.mocky.io/v3/45216a26-e140-4e7c-a1cf-25ed7c1b91f9';
        var url = '/cart/getpricebyquantity';
        var data = { "sku": sku, "qty": qty };
        return $.post(url, data);
    },

    updatePrice: function($inptQty, newPrice) {
        var originalPrice = $inptQty.data('originalPrice') == null
                                ? $inptQty.data('price')
                                : $inptQty.data('originalPrice');

        $inptQty.data('originalPrice', originalPrice);
        $inptQty.data('price', newPrice);
    },

    resetOriginalPrice: function($inptQty) {
        if ($inptQty.data('originalPrice') == null) {
            return;
        }

        var originalPrice = $inptQty.data('originalPrice');
        $inptQty.data('price', originalPrice);
    },

    updatePriceLabel: function(sku, newLabel) {
        var $priceLabl = $("[data-price-label=" + sku + "]");

        if (newLabel == null || $priceLabl.length === 0) {
            return;
        }

        var originalLabel = $priceLabl.data('originalLabel') == null
                                ? $priceLabl[0] && $($priceLabl[0]).text()
                                : $priceLabl.data('originalLabel');

        $priceLabl.data('originalLabel', originalLabel);
        $priceLabl.text(newLabel);
    },

    resetOriginalPriceLabel: function(sku) {
        var $priceLabl = $("[data-price-label=" + sku + "]");

        if ($priceLabl.data('originalLabel') == null) {
            return;
        }

        var originalLabel = $priceLabl[0] && $($priceLabl[0]).data('originalLabel');
        $priceLabl.text(originalLabel);
    },

    updatePriceSelectedVariants: function(sku, price) {
        function updatePrice(item) {
            (item.sku === sku)
                && (item.price = price);

            return item;
        }

        return selectedVariants.map(updatePrice);
    },

    // PDP & PLP list view - Check Local Stock
    checkLocalStock: function($el, sku, qty) {
        var isListingView = Core.Util.isPlp();
        var $page = isListingView ? Core.AddToQuote.Cache.$productListingPage : Core.AddToQuote.Cache.$productDetailContainer;
        var api = $page.data('check-local-stock-api');
        var isCheckLocalStockAsync = Core.Util.isCheckLocalStockAsync();
        
        if (!api) {
            console.log('Please provide the api url for stock check (data-check-local-stock-api)');
            return;
        }

        var location = {
            suburb: $page.attr('data-suburb'),
            state: $page.attr('data-state'),
            postCode: $page.attr('data-postcode'),
        };
        var variants = [{
            qty: qty,
            sku: sku,
            mainsku: sku,
        }];
        var $parent = $el.closest('.product-details__variant');
        var $error = $parent.find('.stock-error');

        $.ajax({
            url: api,
            data: {
                variants: variants,
                location: location,
                setLocation: false,
            },
            type: 'POST',
            dataType: 'json',
            success: function(data) {
                if (data.isSuccess) {
                    var item = data.stocks?.length > 0 && data.stocks[0];
                    if (!item) return;

                    var $row = isListingView ? 
                        $(`.plv__variant-row[data-id="${sku}"]`) :
                        $(`.product-details__variant--row[data-id="${sku}"]`);
                    if ($row.length === 0) return;

                    if (item.value === '') {
                        $row.find('.stock-error').removeClass(CLS_HIDE);
                        return;
                    }

                    var localTemplate = (isCheckLocalStockAsync || isListingView) ? 
                        `${item.value}` : 
                        `${item.value} for ${location.suburb} ${location.postCode}`;
                    var noStockMessage = Core.Util.isEmpty(localTemplate);
                    var $local = $row.find(`.stock-local`);
                    $local.find('.stock-status').css('background-color', item.colour);

                    if (!noStockMessage) {
                        $local.find('.stock-message').html(localTemplate);
                    }
                    $local.addClass(CLS_CHECKED);
                    $row.find('.stock-checkBtn').addClass(CLS_HIDE);
                    $row.find('.stock-updateBtn').removeClass(CLS_HIDE);

                    // keep showing national stock if local stock not available
                    if ((isCheckLocalStockAsync || isListingView) && !noStockMessage) {
                        $row.find('.stock-national').addClass(CLS_HIDE);
                    }
                } else {
                    $error.html(data.message);
                    $error.removeClass(CLS_HIDE);
                }
            },
            error: function(xhr, ajaxOptions, thrownError) {        
                $error.removeClass(CLS_HIDE);
                console.log('error', xhr, ajaxOptions, thrownError);
            }
        });
    },

    // get stock from table/variant
    getStockData: function($parent) {
        var $stock = $parent.find('.stock-wrap').first();

        if ($parent.length === 0 || $stock.length === 0) {
            return { stockMessage: '', stockColor: '' };
        }

        var $stockNational = $stock.find('.stock-national');
        var $stockLocal = $stock.find('.stock-local');

        var stockColor = $stockLocal.length > 0 ? $stockLocal.find('.stock-status').css('background-color') : '';
        var stockMessage = $stockLocal.length > 0 ? $stockLocal.find('.stock-message').text() : '';
        if (Core.Util.isEmpty(stockMessage)) {
            stockMessage = $stockNational.length > 0 ? $stockNational.find('.stock-message').text() : '';
            stockColor = $stockNational.length > 0 ? $stockNational.find('.stock-status').css('background-color') : '';
        }

        return {
            stockMessage: stockMessage,
            stockColor: stockColor,
        };
    },
    // END : DYNAMIC PRICE -------------------------------

    addVariantsPortal: function () {
        var _self = this;
        var isAgedCare = Core.Util.isAgedCare();
        var isWholesale = Core.Util.isWholesale();
        var isListingView = Core.Util.isPlp();
        window.selectedVariants = [];

        var handleUpdateQty = Core.Util.Debounce(function (_$el) {
            var _$elParent  = isListingView ? 
                _$el.closest('.plv__variant-action-wrap') : 
                _$el.closest('.product-details__variant--format--column');

            var _$added     = isWholesale ? 
                    _$el.closest('.product-details__variant--column.product-details__variant--actionwrap')
                        .find('.added') : 
                    _$el.closest('.product-details__variant--column.product-details__variant--format')
                        .siblings('.product-details__variant--column.product-details__variant--actionwrap')
                        .find('.added'),
                _$inptQty   = _$elParent.find("input[name='qty']"),
                _$sku       = _$inptQty.data("id"),
                _$mainsku   = isWholesale ? 
                    _$el.closest('.product-details__variant--table').find('.mainProdSku').val() :
                    _$el.closest('.product-details__variant--format--table').find('.mainProdSku').val(),
                _$price     = _$inptQty.data("price"),
                _$qty       = _$elParent.find("input.product-details__variant--qty:visible").val();

            _$added = (_$added.length > 0)
                        ? _$added
                        : getAddedElement(_$el);

            var __price = _$price;
            _self.getDynamicPrice(_$sku, _$qty)
                .done(function(data) {
                    if (data == null) {
                        return;
                    }

                    data.unitPriceLabel
                        && _self.updatePriceLabel(_$sku, data.unitPriceLabel);

                    data.unitPrice
                        && (__price = parseFloat(data.unitPrice)
                           , _self.updatePrice(_$inptQty, __price));

                    selectedVariants &&
                        (selectedVariants = _self.updatePriceSelectedVariants(_$sku, __price));
                })
                .always(function() {
                    theItem(_$added, _$sku, _$mainsku, _$qty, __price)
                    calculateSelection();
                });

            (isWholesale || isListingView) &&_self.checkLocalStock(_$el, _$sku, _$qty);
        }, 400);

        // On click - qty +/- btns - update cart
        Core.Cache.$document.on("click", ".product-details__variant--qty .k-icon", function() {
            handleUpdateQty($(this));
        });

        var getAddedElement = function($el) {
            var $addedEl = $el.closest('.product-details__variant--price')
                .siblings('.product-details__variant--actionwrap')
                .find('.added');
            
            if ($addedEl.length === 0) {
                $addedEl = $el.closest('.product-details__variant--column-action').find('.added');
            }

            if ($addedEl.length === 0) {
                $addedEl = $el.closest('.plv__variant-action').find('.added');
            }

            return $addedEl;
        }

        // On input - input qty - update cart
        Core.Cache.$document.on("input", "input.product-details__variant--qty:visible", function(){
            var _$el        = $(this),
                _$elParent  = _$el.parent(),
                _$added     = _$el.closest('.product-details__variant--column.product-details__variant--format')
                            .siblings('.product-details__variant--column.product-details__variant--actionwrap')
                            .find('.added'),
                _$inptQty   = _$elParent.find("input[name='qty']"),
                _$sku       = _$inptQty.data("id"),
                _$mainsku   = _$el.closest('.product-details__variant--format--table').find('.mainProdSku').val(),
                _$price     = _$inptQty.data("price"),
                _$qty       = _$el.val(),
                __price     = _$price;

            _$added = (_$added.length > 0)
                ? _$added
                : getAddedElement(_$el);

            if (!_$qty || !_$sku) return;

            // need to call blur event here cause it won't trigger from previous event listener.
            _$el.off('blur').on('blur', function() {
              _self.getDynamicPrice(_$sku, _$qty)
                .done(function(data) {
                    if (data == null) {
                        return;
                    }

                    data.unitPrice
                        && (__price = parseFloat(data.unitPrice)
                           , _self.updatePrice(_$inptQty, __price));

                    data.unitPriceLabel
                        && _self.updatePriceLabel(_$sku, data.unitPriceLabel);

                    selectedVariants &&
                        (selectedVariants = _self.updatePriceSelectedVariants(_$sku, __price));
                })
                .always(function() {
                    theItem(_$added, _$sku, _$mainsku, _$qty, __price)
                    calculateSelection();
                });
                
                (isWholesale || isListingView) && _self.checkLocalStock(_$el, _$sku, _$qty);
            });
        });

        // On close products variants - remove item
        Core.Cache.$document.on("click", ".product-details__variants.is-portalsite .related-products__accordion-tab", function(){
            var _$this = $(this),
                _$content = _$this.siblings('.related-products__accordion-content');

                if(_$content.is(":visible")){
                    var _$added = _$content.find('.added');
                    $.each(_$added , function (i, e) {
                        var _$el    = $(e),
                            _inputBox = _$el.closest('.product-details__variant--table'),
                            _inputData = _inputBox.find('.product-details__variant--qty:visible').find("input[name='qty']"),

                            _sku = _inputData.data('id'),
                            _mainsku = _inputBox.find('.mainProdSku').val(),
                            _price = _inputData.data('price'),
                            _qty = _inputBox.find('.product-details__variant--qty:visible input.product-details__variant--qty:visible').val();


                        _$el.removeClass('added');
                        _inputData.data('kendoNumericTextBox').value(0);
                        _inputBox.find(".k-formatted-value.product-details__variant--qty").val(1);
                        _inputBox.find('.k-numerictextbox').slideUp(300);

                        // without the added class it does remove the item
                        theItem(_$el, _sku, _mainsku, _qty, _price);

                        _self.resetOriginalPrice(_inputData);
                        _self.resetOriginalPriceLabel(_sku);
                    });

                    calculateSelection();
                };
        });

        // On click - drop down menu (buy | rent | rent own)
        Core.Cache.$document.on("click", '.product-details__variant--type span', function () {
            var _$this = $(this),
                _$variant = _$this.closest('.product-details__variant'),
                _$triggerWrap = _$this.closest('.product-details__variant--typewrap'),
                _$triggerButton = _$triggerWrap.find('.product-details__variant--cart'),
                dataType = _$this.data("type");

            // User is adding an item to the cart, button isn't disabled
            var _closestTableWrap = _$this.closest('.product-details__variant--table'),
                _relatedQty = _closestTableWrap.find('.product-details__variant--format--column[data-type="'+ _$this.data('type') +'"]').find('input[name="qty"]'),
                _sku = _relatedQty.data('id'),
                _mainsku = _closestTableWrap.find('.mainProdSku').val(),
				_price = _relatedQty.data('price'),
                _qty = _relatedQty.siblings('input.product-details__variant--qty').val(),
                _$variant = _$triggerButton.parents('.product-details__variant');

            _$triggerButton.toggleClass('added');
            _$variant.toggleClass('selected');
            _$variant.data('type', dataType);
            _$triggerWrap.removeClass('show-type');

            //set selection/
            theItem(_$triggerButton, _sku, _mainsku, _qty, _price, dataType);
            calculateSelection();
            showAccessories(_$variant);
        });

        // On click - main product blue button - add to cart
        Core.Cache.$document.on("click", '.product-details__variant--cart', function () {
            var _$this = $(this);
            var _$parent = _$this.closest('.product-details__variant--typewrap');
            var _$variant = _$this.closest('.product-details__variant');

            if (_$this.hasClass('disabled')) { return false; }

            if (!_$this.hasClass('added')) {
                // toggle button option dropdown
                if (!isAgedCare) {
                    _$parent.toggleClass('show-type');
                } else {
                    // get first variant which will be "buy" for agedCare
                    var $buyType = _$parent.find('.product-details__variant--type li:first-child span');
                    if ($buyType.length) $buyType.trigger('click');
                }
            } else {
                var _$tableWrap = _$this.closest('.product-details__variant--table');
                var _$sibling = _$tableWrap.siblings('.related-products');
                var _$singleKendoWrap = _$tableWrap.find('.k-numerictextbox');

                if (_$sibling.length == 0) {
                    var _inputBox = _$this.closest('.product-details__variant--table'),
                        _inputData = _inputBox.find('.product-details__variant--qty:visible').find("input[name='qty']"),
                        _sku = _inputData.data('id'),
                        _mainsku = _inputBox.find('.mainProdSku').val(),
                        _price = _inputData.data('price'),
                        _qty = _inputBox.find('.product-details__variant--qty:visible input.product-details__variant--qty:visible').val();

                    _$variant.removeClass('selected');
                    _$variant.find('.selected').removeClass('selected');
                    _$tableWrap.find('.added').removeClass('added');
                    _$singleKendoWrap.find("input[name='qty']").data('kendoNumericTextBox').value(0);
                    _$singleKendoWrap.find(".k-formatted-value.product-details__variant--qty").val(1);
                    _$singleKendoWrap.slideUp(300);

                    _self.resetOriginalPrice(_$singleKendoWrap.find("input[name='qty']"));
                    _self.resetOriginalPriceLabel(_sku);

                    //update and set selection for trigger button
                    theItem(_$this, _sku, _mainsku, _qty, _price);
                    calculateSelection();
                } else {
                    //update and set selection for related product if any
                    _$tableWrap.siblings('.related-products').each(function () {
                        var _$added = _$variant.find('.added');
                        for(var a=0; a < _$added.length; a++){
                            var _$addedElement = $(_$added[a]),
                                _$closestVariantTable = _$addedElement.closest('.product-details__variant--table'),
                                _$itemKNumerictexbox = _$closestVariantTable.find('.k-numerictextbox:visible'),
                                _$itemSelected = _$itemKNumerictexbox.find("input[name='qty']"),
                                _sku =  _$itemSelected.data('id');

                            _$itemKNumerictexbox.slideUp(300);
                            _$addedElement.removeClass('added');

                            _$itemKNumerictexbox.find(".k-formatted-value.product-details__variant--qty").val(1);
                            _$itemSelected.data('kendoNumericTextBox').value(0);

                            _self.resetOriginalPrice(_$itemSelected);
                            _self.resetOriginalPriceLabel(_sku);


                            theItem(
                                _$addedElement,
                                _$itemSelected.data('id'),
                                _$closestVariantTable.find('.mainProdSku').val(),
                                _$itemKNumerictexbox.find('input.product-details__variant--qty:visible').val(),
                                _$itemSelected.data('price')
                            );
                        }
                        _$variant.find('.k-numerictextbox').slideUp(300);

                        calculateSelection();
                    }).slideUp(300, function () {});
                }
            }
        });

        Core.Cache.$document.on("click", '.product-details__variant--title span.next-item', function () {
            var _$this = $(this);

            // Close current group accordian and deselect any previously selected variants
            var _$parentGroup = _$this.closest(".related-products__accordion-item");
            _$parentGroup.find("span.added").trigger("click");
            _$parentGroup.find(".related-products__accordion-tab").trigger("click");

            var _$nextGroup;
            if (_$parentGroup.next().length > 0) {
                _$nextGroup = _$parentGroup.next();
            } else {
                var _$parentParentGroup = _$parentGroup.closest(".related-products__accordion-content").closest(".related-products__accordion-item");
                if (_$parentParentGroup.next().length > 0) {
                    _$nextGroup = _$parentParentGroup.next();
                }
            }

            _$nextGroup.find(".related-products__accordion-tab").trigger("click");
        });

        function calculateSelection() {
            var _$added = $('span.added'),
                _$arrBuy = [],
                _$arrrent = [],
                _$arrrenttoown = [],
                _$totbuy = 0,
                _$totrent = 0,
                _$totrenttoown = 0,
                _$sumPrice = 0,
                _$totalSumWrap = $('.product-details__total')
                _$buyTotalElement = $('.buyTotal'),
                _$rentTotalElement = $('.rentTotal'),
                _$rentoownTotalElement = $('.rentToOwnTotal');

            if(_$added.length > 0) {
                $.each(_$added , function (i, e) {
                    var _$el        = $(e),
                        _$res       = 0,
                        _$qtyBox    = _$el.closest('.product-details__variant--table'),
                        _$activeQty = _$qtyBox.find('input.product-details__variant--qty:visible'),
                        _$elQty     =  _$activeQty.parent().find("input[name='qty']")
                        _$elQtyMin  = _$elQty.attr("min") > 0 ? _$elQty.attr("min") : 1,
                        _$elQtyVal  = 1;

                    if (_$activeQty.val() >= _$elQtyMin) {
                        _$elQtyVal = _$activeQty.val();
                    } else {
                        _$elQtyVal = 1;
                        _$activeQty.val(1);
                    }

                   _$res = parseFloat(_$elQty.data('price')) * parseFloat(_$elQtyVal);
                   switch (_$activeQty.closest('.product-details__variant--format--column').data('type')) {
                        case "buy":
                            _$totbuy += _$res;
                        break;
                        case "rent":
                            _$totrent += _$res;
                        break;
                        case "renttoown":
                            _$totrenttoown += _$res;
                        break;
                    };
                });

                _$buyTotalElement.children("span").html(!isNaN(_$totbuy.toFixed(2)) ? _$totbuy.toFixed(2): "0.00");
                _$rentTotalElement.children("span").html(!isNaN(_$totrent.toFixed(2))? _$totrent.toFixed(2): "0.00");
                _$rentoownTotalElement.children("span").html(!isNaN(_$totrenttoown.toFixed(2))? _$totrenttoown.toFixed(2): "0.00");
                _$totalSumWrap.slideDown(300);
            } else {
                _$buyTotalElement.children("span").html("0.00");
                _$rentTotalElement.children("span").html("0.00");
                _$rentoownTotalElement.children("span").html("0.00");
                _$totalSumWrap.slideUp(300);
            }
        }

        function theItem($addCartButton, $sku, $mainsku, $qty, $price, $selectFormat) {
            var _$el = $addCartButton,
                _$sku = $sku,
                _$mainsku = $mainsku,
                _$qty = $qty,
                _$price = $price,
                _$format = $selectFormat || false
                _$parentTable = _$el.closest('.product-details__variant--table');
            
            var stockData = Core.AddToQuote.getStockData(_$parentTable);

            if (_$el.hasClass('added')) {
                // Add initial item
                function CallbackFunctionToFindBySku(selectedVariants) {
                    return selectedVariants.sku === _$sku;
                };

                function changeQty(sku, qty) {
                   for (var i in selectedVariants) {
                     if (selectedVariants[i].sku == sku) {
                        selectedVariants[i].qty = qty;
                        break; //Stop this loop, we found it!
                     }
                   }
                };


                // new find in object, the previous ones CallbackFunctionToFindBySku() doesn't works
                var findInObject = selectedVariants.filter(function (selectedVariants) { return selectedVariants.sku === _$sku });
                //var findInObject = selectedVariants.find(CallbackFunctionToFindBySku);

                if (findInObject.length > 0) {
                    changeQty(_$sku, _$qty);
                } else {
                    selectedVariants.push({
                        sku: _$sku,
                        mainsku: _$mainsku,
                        qty: _$qty,
                        price: _$price,
                        stockmessage: stockData.stockMessage,
                        stockcolor: stockData.stockColor,
                    });
                }
            } else {
                // Remove item from cart
                for (var i = 0; i < selectedVariants.length; i++) {
                    if (selectedVariants[i]['sku'] == _$sku) {
                        selectedVariants.splice(selectedVariants.indexOf(selectedVariants[i]), 1);
                        break;
                    }
                }
            }

            // Get all product code ID's
            var productCode = $('span.added');
            var blkstr = [];

            $.each(productCode, function (i, e) {
                var qtyActive = $(e)
                    .closest('.product-details__variant--table')
                    .find('.product-details__variant--qty:visible')
                    .find("input[name='qty']")
                    .data("id");

                blkstr.push(qtyActive);
            });

            if (selectedVariants.length === 0) {
                $(Core.AddToQuote.Cache.addToQuoteSelector)
                    .add(Core.AddToQuote.Cache.$rentBtn)
                    .add(Core.AddToQuote.Cache.$trialBtn)
                    .addClass('disabled');
            } else {
                $(Core.AddToQuote.Cache.addToQuoteSelector)
                    .add(Core.AddToQuote.Cache.$rentBtn)
                    .add(Core.AddToQuote.Cache.$trialBtn)
                    .removeClass('disabled');
            }

            // only for select variant with format
            if (_$format) {
                // Handle Kendo Number Box
                var _$variantParent = _$el.closest('.product-details__variant--table');
                var _$kendoNumericTextBox = _$variantParent.find('[data-type="' + _$format + '"]').find('.k-numerictextbox');

                if (_$kendoNumericTextBox.length > 0) {
                    _$kendoNumericTextBox.find("input[name='qty']").data('kendoNumericTextBox').value(1);
                    _$kendoNumericTextBox.slideDown();
                } else {
                    //$(".product-details__selections").find('.k-numerictextbox').enable(true);
                    var _$selectionQuantity = $('.product-details__selections').find('#selection_qty');
                    this.numerictextbox = _$selectionQuantity.data('kendoNumericTextBox');
                    this.numerictextbox.enable(_$el.hasClass('added'));
                }
            }

            if (Core.AddToQuote.Cache.$productDetailContainer.length > 0) {
                Core.ProductDetail.Cache.$rentalForm.find('.productCode').val(blkstr.join(','));
                Core.ProductDetail.Cache.$trialForm.find('.productCode').val(blkstr.join(','));

                // if select variant with format
                if (_$format) {
                    _$variantParent.siblings('.related-products').slideDown(400, function () { });
                }
            }

            // Group Pricing
            var _groupPrice = 0;
            var _$groupCodeStr = [];
            for (var x = 0; x < selectedVariants.length; x++) {
                _groupPrice += parseFloat(selectedVariants[x].price * selectedVariants[x].qty);
                _$groupCodeStr.push(selectedVariants[x].mainsku);
            }

            if (_$groupCodeStr.length === 0) {
                Core.AddToQuote.Cache.$groupPrice.hide();
                Core.AddToQuote.Cache.$groupCode.hide();
                if (Core.AddToQuote.Cache.$productDetailContainer.length > 0) {
                    Core.ProductDetail.Cache.$trialForm.hide();
                    Core.ProductDetail.Cache.$rentalForm.hide();
                }
            } else {
                if (_groupPrice > 0) {
                    Core.AddToQuote.Cache.$groupPrice.text('$' + _groupPrice.toFixed(2)).show();
                } else {
                    Core.AddToQuote.Cache.$groupPrice.text(Core.Config.POA.Text).show();
                }

                if (_$groupCodeStr.length === 1) {
                    Core.AddToQuote.Cache.$groupCode.text("SKU# " + _$groupCodeStr.join(", ")).show();
                } else {
                    Core.AddToQuote.Cache.$groupCode.text("SKU# " + "Multiple Selections").show();
                }
            }
        }

        function showAccessories($variant) {
            var CLS_HIDE = 'hidden';
            var CLS_INVISIBLE = 'invisible';
            var dataType = $variant.data('type');
            var $pricesAcc = $variant.find('.related-products .product-details__variant--format--column');

            var $itemRow = $variant.find('.related-products .product-details__variant--table');
            $itemRow.removeClass(CLS_HIDE);

            //hide price accessories
            $pricesAcc.removeClass(CLS_INVISIBLE);

            //hide cart action
            var $cartAction = $variant.find('.related-products .product-details__variant--type > li > span');
            $cartAction.removeClass(CLS_HIDE);
        }
    },

    addToCartPortal: function () {
        Core.Cache.$document.on("click", Core.AddToQuote.Cache.addToQuoteSelector, function () {
            var _$this = $(this);
            if (!_$this.hasClass('disabled')) {
                Core.ShowPageLoading();

                Core.AddToQuote.Cache.$rentBtn.removeClass('selected');
                Core.AddToQuote.Cache.$trialBtn.removeClass('selected');
                var stockData = Core.AddToQuote.getStockData(_$this.closest('.product-details__variant'));

                if (selectedVariants.length === 0) {
                    var _variant = {};

                    _variant.sku = _$this.data('id');
                    _variant.qty = 1;
                    _variant.stockcolor = stockData.stockColor;
                    _variant.stockmessage = stockData.stockMessage;

                    selectedVariants.push(_variant);
                }

                Core.AddToQuote.addToCartPortalApi(selectedVariants);
            }
        });
    },

    addToCartPortalApi: function(selectedVariants, cta) {      
        var url = '/cart/addtocart'; // 'https://run.mocky.io/v3/5ec8c0bf-26d9-4b00-8d75-ecc19d3f48a9';        
        $.post(`${url}?_=` + new Date().getTime().toString(), { '': selectedVariants })
            .done(
                function(data, status, headers, config) {
                    Core.HidePageLoading();

                    Core.Engine.getCartSummary();

                    //check which items have been successful
                    var _successfulItems = [];
                    for (var x = 0; x < data.length; x++) {
                        _successfulItems.push(data[x]);
                    }

                    if (_successfulItems.length > 0) {
                        var _$addToCartWindow = $('#cart-notification');
                        var _template = '#tpl-cart-notification';

                        if (cta) {
                            _$addToCartWindow = $(`.cart-notification--${cta}`);
                            _template = `#tpl-cart-notification--${cta}`;
                        }

                        Core.RenderTemplate(_template, _successfulItems, _$addToCartWindow.find('.cart-notification-content'));
                        Core.AddToQuote.initPopup(_$addToCartWindow);
                        _$addToCartWindow.removeClass('hidden');

                        $(".k-overlay").on('click', function () {
                            _$addToCartWindow.data("kendoWindow").close();
                        });

                        $(".k-window-action > span.k-i-close, .cart-notification-buttons > a.k-i-close").on('click', function (e) {
                            e.preventDefault();
                            _$addToCartWindow.data("kendoWindow").close();
                        });

                        window.selectedVariants = [];
                        // reset button state
                        $('.product-details__variant--cart.added').each(function() {
                            var $this = $(this);
                            // prevent child that has been closed to re-trigger
                            if ($this.hasClass('added')) $this.trigger('click');
                        });

                        if (Core.ProductDetail.Cache) {
                            Core.ProductDetail.closeFormField(Core.ProductDetail.Cache.$trialForm);
                            Core.ProductDetail.closeFormField(Core.ProductDetail.Cache.$rentalForm);
                        }

                        // reload cart flyout
                        Core.CartFlyout.init();
                    }
                    else {
                        //todo: do something when no items have been added
                        alert('Sorry, that was a problem adding items to your cart');
                    }
                })
            .fail(
                function (data, status, headers, config) {
                    //todo: do something
                });
    },

    initPopup: function ($popup) {
        var _width = Core.Config.CartNotification.Width;

        if (Core.IsMobile()) {
            _width = Core.Cache.$window.width();
        }

        $popup = $popup.kendoWindow({
            width: _width,
            visible: false,
            iframe: false,
            modal: true,
            resizable: false,
            actions: ["Close"],
            pinned: true,
            draggable: false,
            appendTo: '#page-wrap',
            close: function () {
                $('body').css('overflowY', '');
            }
        });

        var popUpObj = $popup.data("kendoWindow");
        popUpObj.wrapper.addClass('cart-notification__wrapper');

        $('body').css('overflowY', 'hidden');
        popUpObj.open();

        setTimeout(function () {
            Core.AddToQuote.setPopupHeight($popup);
        }, 100);
    },

    setPopupHeight: function ($popup) {
        //set max-height of popup-content
        var $content = $popup.find('.cart-notification-content')
            , $buttonWrap = $popup.find('.cart-notification-buttons')
            , buttonH = $buttonWrap.outerHeight()
            , popupH = $popup.outerHeight() + 80 + buttonH //80px is gap top and bottom
            , windowH = window.innerHeight
            , $header = $popup.find('.k-window-titlebar');

        if (popupH > windowH) {
            var contentH = windowH - buttonH - $header.outerHeight() - 130; //130 = padding-top + padding-bottom + (top + bottom popup's position)
            $content.css('max-height', contentH + "px");
        } else {
            $content.css('max-height', '');
        }
    },

    isPortal: function() {
        return $('.product-details__variants').hasClass('is-portalsite')
            || $('#product-listing').hasClass('is-portalsite')
            || $('#favourites').hasClass('is-portalsite');
    },

    isEventBased: function() {
        return $('[data-type="eventbased"]').length > 0;
    }
};

Handlebars.registerHelper('cartMsgHasPriceType', function (msgLst, priceType) {
    for (var i = 0; i < msgLst.length; i++) {
        if (msgLst[i]['PriceType'] == priceType) {
            return true;
        }
    }

    return false;
});

Handlebars.registerHelper('cartMsgIsPriceType', function (priceType, priceTypeCompare) {
    return (priceType == priceTypeCompare);
});
